import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface ScoreBreakdownItemProps {
  label: string;
  value: number;
  isNegative?: boolean;
}

function ScoreBreakdownItem(props: ScoreBreakdownItemProps): JSX.Element {
  const { label, value, isNegative = false } = props;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ paddingY: 2 }}>
      <Text
        variant="body2"
        color={(theme) =>
          isNegative ? theme.palette.intent?.error.text : theme.palette.text.secondary
        }
      >
        {label}
      </Text>
      <Text
        variant="body1"
        color={(theme) =>
          isNegative ? theme.palette.intent?.error.text : theme.palette.text.primary
        }
      >
        {value}
      </Text>
    </Stack>
  );
}

interface ScoreBreakdownListProps {
  currentScore: number;
  scoreChange: number;
  policyLabel: string;
}

export function ScoreBreakdownList(props: ScoreBreakdownListProps): JSX.Element {
  const { currentScore, scoreChange, policyLabel } = props;

  const hasScoreChange = scoreChange !== 0;

  return (
    <Stack sx={{ paddingX: 6, paddingY: 4 }}>
      <ScoreBreakdownItem label="Current Clipboard Score" value={currentScore} isNegative={false} />
      {hasScoreChange && (
        <ScoreBreakdownItem label={policyLabel} value={scoreChange} isNegative={scoreChange < 0} />
      )}
    </Stack>
  );
}
